import type { ReactNode } from "react";

import { Box } from "@braintrust/braintrust-ui-components";
import { HeaderPortal } from "@js/apps/jobs/components/header-portal";

import { ExternalJobPostingPopoverButton } from "../external-job-posting";

import type { HeaderButtonProps } from "./button";
import { HeaderButton } from "./button";
import { VisibilitySettingsPopover } from "./popover";

export type CreateJobHeaderPortalProps = HeaderButtonProps & {
  displaySettings?: boolean;
  rightSocket?: ReactNode;
  onClick?: () => void;
  leftSocket?: ReactNode;
};

export const CreateJobHeaderPortal = ({
  backLink,
  isEdit,
  rightSocket,
  displaySettings,
  onClick,
  leftSocket,
}: CreateJobHeaderPortalProps) => {
  return (
    <HeaderPortal
      rightSocket={rightSocket}
      leftSocket={
        <Box sx={{ display: "inline-flex", gap: "8px", flexWrap: "wrap" }}>
          <HeaderButton isEdit={isEdit} backLink={backLink} onClick={onClick} />
          {displaySettings && (
            <>
              <VisibilitySettingsPopover />
              <ExternalJobPostingPopoverButton />
            </>
          )}
          {leftSocket}
        </Box>
      }
    />
  );
};
